import React, { useState, useCallback } from 'react';
import { Modal, Button, Checkbox } from 'gatorcomponents';
import * as Styles from './SubscriptionCancelVPSModal.styles';
import { SubscriptionCancelVPSModalProps } from './SubscriptionCancelVPSModal.types';

const SubscriptionCancelVPSModal = ({
  titleLabel = 'Cancel subscription',
  descriptionLabel = {
    hosting: 'Select the form you want below:',
    addon: 'Select the form you want below:',
  },
  quitButtonLabel = 'Give up action',
  continueButtonLabel = 'Continue',
  type = 'hosting',
  agreedOptionsLabel = {
    hosting: {
      agreedMigrationResponsibility: 'I understand that if I change my mind, I will need to hire a new plan and manually migrate the data.',
      agreedDataDeletion: 'I know that by canceling, all data and configurations of this VPS will be irreversibly deleted.',
    },
    addon: {
      agreedDataDeletion: 'I know that by canceling this panel and/or application, all data and configurations of this VPS will be irreversibly deleted.',
    },
  },
  onCloseClick,
  onContinueButtonClick,
  onQuitButtonClick,
}) => {
  const initializeFormData = () => {
    const options = agreedOptionsLabel[type] || {};
    const initialData = {};
    Object.keys(options).forEach((key) => {
      initialData[key] = false;
    });
    return initialData;
  };

  const [formData, setFormData] = useState(initializeFormData);

  const handleOnCloseClick = (event) => {
    onCloseClick && onCloseClick(event);
  };

  const handleOnQuitButtonClick = (event) => {
    onQuitButtonClick && onQuitButtonClick(event);
  };

  const handleOnContinueButtonClick = (event) => {
    onContinueButtonClick && onContinueButtonClick(event);
  };

  const handleChange = useCallback(({ key, value }) => {
    setFormData({
      ...formData,
      [key]: value,
    });
  }, [
    formData,
  ]);

  const isFormIncomplete = useCallback(() => Object.values(formData).some(value => value === false), [formData]);

  return (
    <Styles.Wrapper>
      <Modal
        maxWidth={800}
        disablePadding
        noHeader
        onClose={handleOnCloseClick}
        testId="subscription-manage-cancel-vpsoci-modal"
      >
        <Styles.Content>
          <Styles.Header>
            <Styles.Title data-testid="subscription-manage-cancel-modal-title">{titleLabel}</Styles.Title>
            <Styles.Description data-testid="subscription-manage-cancel-vpsoci-modal-description">
              {descriptionLabel[type]}
            </Styles.Description>
          </Styles.Header>
          <Styles.InputsWrapper>
            {Object.entries(agreedOptionsLabel[type] || {}).map(([key, label]) => (
              <Styles.CheckboxLabel
                key={key}
                htmlFor={`#readTerms${key}`}
                data-testid={`checkReadTerms${key}`}
                onClick={() => handleChange({ key, value: !formData[key] })}
              >
                <Checkbox checked={formData[key] || false} id={`readTerms${key}`} />
                <Styles.Text>
                  {label}
                </Styles.Text>
              </Styles.CheckboxLabel>
            ))}
          </Styles.InputsWrapper>

          <Styles.Controls>
            <Button
              testId="subscription-manage-cancel-vpsoci-modal-quit-button"
              onClick={handleOnQuitButtonClick}
              label={quitButtonLabel}
              variant="secondary"
              size="large"
              version="v2"
            />
            <Button
              testId="subscription-manage-cancel-vpsoci-modal-continue-button"
              onClick={handleOnContinueButtonClick}
              label={continueButtonLabel}
              variant="primary"
              size="large"
              version="v2"
              disabled={isFormIncomplete()}
            />
          </Styles.Controls>
        </Styles.Content>
      </Modal>
    </Styles.Wrapper>
  );
};

SubscriptionCancelVPSModal.propTypes = SubscriptionCancelVPSModalProps;

export default SubscriptionCancelVPSModal;
